import { render, staticRenderFns } from "./datatableSolu.vue?vue&type=template&id=03b034d9&"
import script from "./datatableSolu.vue?vue&type=script&lang=ts&"
export * from "./datatableSolu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('03b034d9', component.options)
    } else {
      api.reload('03b034d9', component.options)
    }
    module.hot.accept("./datatableSolu.vue?vue&type=template&id=03b034d9&", function () {
      api.rerender('03b034d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Cotizador/datatableSolu.vue"
export default component.exports